import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {NotificationsHttpService} from '../../../../services/http-services/notifications/notifications-http.service';
import {GrPagination} from '../../../../interfaces/general-interfaces';
import {NgForOf, SlicePipe} from '@angular/common';

@Component({
  selector: 'gr-notification-custom-tab',
  standalone: true,
  templateUrl: './notification-custom-tab.component.html',
  imports: [
    NgForOf,
    SlicePipe
  ]
})
export class NotificationCustomTabComponent implements OnInit, OnChanges {
  @Input() updateNotification = false;
  @Output() editNotification: EventEmitter<any> =  new EventEmitter<any>();
  customNotificationsPagination: GrPagination | undefined;
  customNotifications: any[] = [];
  urlParams = {page: 1};
  isRequestFinish = false;

  constructor(private notificationsHttpService: NotificationsHttpService) {
  }

  ngOnInit(): void {
    this.customNotificationsPagination = undefined;
    this.customNotifications = [];
    this.getNotifications();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('CHANGES CHANGES', changes)
    if (changes.updateNotification.currentValue) {
      this.urlParams.page = 1;
      this.customNotificationsPagination = undefined;
      this.customNotifications = [];
      this.getNotifications();
    }
  }

  getNotifications(): void {
    this.urlParams.page = (this.customNotificationsPagination?.currentPage) ? this.customNotificationsPagination.currentPage + 1 : 1;
    this.notificationsHttpService.getCustomNotifications(this.urlParams).then(res => {
      this.customNotifications = [...this.customNotifications, ...res.data];
      this.customNotificationsPagination = res.pagination;
      this.isRequestFinish = true;
    });
  }

  onScroll(event: any): void {
    const threshold = 100;
    const position = event.target.scrollTop + event.target.offsetHeight;
    const height = event.target.scrollHeight;

    if (position > height - threshold && (this.customNotificationsPagination?.currentPage ?? 0) < (this.customNotificationsPagination?.lastPage ?? 0) && this.isRequestFinish) {
      this.isRequestFinish = false;
      this.getNotifications();
    }
  }
}
